import React from 'react';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import commafy from '../../../utils/commafyHelper';
import './history.scss';
import CustomButton from '../../../components/UI/CustomButton';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'transparent',
    boxShadow: 'none !important',
    border: '1px solid #DCDFE1 !important',
    borderRadius: '0.5rem !important',
  },

  accordionDetailsRoot: {
    padding: '0 1rem',
  },
}));

const HistoryItem = ({ historyItem, lastItem, setOpenUsersUsedProduct, setTransferCode }) => {
  const styles = useStyles({ lastItem });
  const {
    status,
    amount = 0,
    paymentCode,
    transactionType,
    productName,
    transactionDate,
    quantity,
    type,
    transferCode,
  } = historyItem;

  return (
    <Box className='historyItem'>
      <Accordion classes={{ root: styles.root }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color='action' />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Box className='historyItemRow'>
            <Typography
              color={
                productName
                  ? 'secondary.main'
                  : transactionType === 'Purchase'
                  ? 'secondary.main'
                  : status === 1
                  ? 'success.main'
                  : 'error.main'
              }
              fontWeight='bold'
            >
              {transactionType === 'Transfer'
                ? `انتقال (${productName})`
                : transactionType === 'Purchase'
                ? `خرید`
                : status === 1
                ? 'واریز (موفق)'
                : 'واریز (ناموفق)'}
            </Typography>
            <Typography
              color={
                productName
                  ? 'secondary.main'
                  : transactionType === 'Purchase'
                  ? 'secondary.main'
                  : status === 1
                  ? 'success.main'
                  : 'error.main'
              }
            >
              {amount !== 0 ? (
                <Typography>
                  {commafy(amount)}
                  <span>تومان</span>
                </Typography>
              ) : (
                `${quantity} کاربر`
              )}
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails classes={{ root: styles.accordionDetailsRoot }}>
          {transactionType === 'Deposit' && (
            <Box className='historyItemRow'>
              <Typography color='text.dark' fontWeight='lighter'>
                وضعیت:
              </Typography>
              <Typography color={status === 1 || productName ? 'success.main' : 'error.main'}>
                {status === 1 || productName ? 'موفق' : 'ناموفق'}
              </Typography>
            </Box>
          )}

          <Box className='historyItemRow'>
            <Typography color='text.dark' fontWeight='lighter'>
              تاریخ موثر:
            </Typography>
            <Typography color='text.dark' dir='ltr'>
              {transactionDate}
            </Typography>
          </Box>

          <Box className='historyItemRow'>
            <Typography color='text.dark' fontWeight='lighter'>
              شناسه پرداخت:
            </Typography>
            <Typography color='text.dark'>{paymentCode}</Typography>
          </Box>

          {type === 3 && (
            <Box className='historyItemRow'>
              <CustomButton
                variant='contained'
                onClick={() => {
                  setTransferCode(transferCode);
                  setOpenUsersUsedProduct(true);
                }}
              >
                جزئیات انتقال
              </CustomButton>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default HistoryItem;
